<template>
  <v-card flat rounded="lg">
    <v-card-text>
      <v-list-item dense two-line>
        <v-list-item-avatar size="65" class="justify-center grey lighten-4">
          <v-row dense>
            <v-col cols="12" class="pt-0 pb-0">
              <span class="caption">Meu ID</span>
            </v-col>
            <v-col class="pt-0">
              <span class="font-weight-bold subtitle-2 primary--text" :style="{'letter-spacing': '1.1px !important'}">{{
                candidato.id
              }}</span>
            </v-col>
          </v-row>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle>Candidato</v-list-item-subtitle>
          <v-list-item-title class="font-weight-bold primary--text">{{
            candidato.nome
          }}</v-list-item-title>
          <v-list-item-subtitle class="mt-2"
            >Data Nascimento</v-list-item-subtitle
          >
          <v-list-item-title class="font-weight-bold primary--text">{{
            formatarData(candidato.dtnasc)
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-row dense class="mt-2">
        <v-col cols="12">
          <btn-desconectar label="Desconectar" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import BtnDesconectar from "../botoes/BtnDesconectar.vue";
export default {
  components: { BtnDesconectar },
  computed: {
    ...mapState(["candidato"]),
  },
  methods: {
    formatarData(value) {
      return moment(value).format("DD/MM/YYYY");
    },
  },
};
</script>

<style>
</style>